import React from 'react';
import PropTypes from 'prop-types';
import { UserContext } from '../Context';

function RestrictedContent({
  group,
  children,
}) {
  return (
    <UserContext.Consumer>
      {(user) => (user.isInGroup(group) && children)}
    </UserContext.Consumer>
  );
}

RestrictedContent.propTypes = {
  group: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node,
};

RestrictedContent.defaultProps = {
  children: null,
};

export default RestrictedContent;
